import React from "react";

const SvgClock = ({ color = "currentColor", ...props }) => (
  <svg width="22" viewBox="0 0 22 22" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 20.1668C5.94004 20.1668 1.83337 16.0693 1.83337 11.0002C1.83337 5.94016 5.94004 1.8335 11 1.8335C16.0692 1.8335 20.1667 5.94016 20.1667 11.0002C20.1667 16.0693 16.0692 20.1668 11 20.1668ZM13.9242 14.401C14.0342 14.4652 14.1534 14.5018 14.2817 14.5018C14.5109 14.5018 14.74 14.3827 14.8684 14.1627C15.0609 13.8418 14.96 13.4202 14.63 13.2185L11.3667 11.2752V7.04016C11.3667 6.65516 11.055 6.35266 10.6792 6.35266C10.3034 6.35266 9.99171 6.65516 9.99171 7.04016V11.6693C9.99171 11.9077 10.12 12.1277 10.3309 12.256L13.9242 14.401Z"
      fill={color}
    />
  </svg>
);

export default SvgClock;
